import { render, staticRenderFns } from "./PayChart.vue?vue&type=template&id=67e63bf1&scoped=true&"
import script from "./PayChart.vue?vue&type=script&lang=js&"
export * from "./PayChart.vue?vue&type=script&lang=js&"
import style0 from "./PayChart.vue?vue&type=style&index=0&id=67e63bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e63bf1",
  null
  
)

component.options.__file = "PayChart.vue"
export default component.exports